import { Latest } from 'app/blocks/homepage/latest'
import { ContentCardProps } from 'app/components/content/ContentCard'
import { ContentCardBookmarkable } from 'app/components/content/ContentCard/ContentCardBookmarkable'
import Section from 'app/components/structure/Section'
import React, { useCallback } from 'react'
import { useCarouselController } from 'app/hooks/use-carousel-controller'
import { useWatchLaterContext } from 'app/providers/WatchLaterProvider'
import { XStack, YStack } from '@mythical/ui'
import { Button } from 'app/components/primitive/Button'
import {
  IconChevronLeft,
  IconChevronRight,
} from 'app/components/primitive/Icon'
import { ContentCarousel } from 'app/components/content/ContentCarousel'

export const LatestBlock: React.FC<{ block: Latest }> = ({ block }) => {
  const { title, content } = block || {}
  const controller = useCarouselController()
  const { isInWatchLater, toggleWatchLater } = useWatchLaterContext()

  if (!content || content?.length === 0) {
    return null
  }

  const items = content as ContentCardProps[]

  const renderItem = useCallback(
    (item: ContentCardProps) => (
      <ContentCardBookmarkable
        {...item}
        isInWatchLater={isInWatchLater(item.id)}
        onToggleWatchLater={toggleWatchLater}
      />
    ),
    [isInWatchLater, toggleWatchLater],
  )

  const keyExtractor = useCallback((item: ContentCardProps) => item.id, [])

  return (
    <Section
      paddedX
      title={title || 'Recently Updated'}
      customCta={
        <XStack gap="$2" $sm={{ dsp: 'none' }}>
          <Button
            theme="white"
            onPress={controller.scrollToPrevious}
            disabled={!controller.canScrollPrevious}
            aria-label="Previous"
            icon={<IconChevronLeft size={16}  />}
            size="$3.5"
            circular
          />
          <Button
            theme="white"
            onPress={controller.scrollToNext}
            disabled={!controller.canScrollNext}
            aria-label="Next"
            circular
            size="$3.5"
            icon={<IconChevronRight size={16}  />}
          />
        </XStack>
      }
    >
      <YStack $gtSm={{ overflow: 'hidden' }}>
        <ContentCarousel
          items={items}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          controllerRef={controller.carouselRef}
        />
      </YStack>
    </Section>
  )
}
